import { DefaultSuccess } from 'type/http';
import { User } from 'type/user';
import Request from './request';

const request = new Request('meeting');

export const getUserInfo = (userId: string) => {
  return request.get<User>(`/api/users/${userId}`);
};

type PersonConfig = {
  code: string;
  message: string;
  data: string;
}
/**
 * 获取用户个人配置
 * @param type number 配置类型：1|日程共享，2|默认员工身份
 */
export const getPersonConfig = (type: number = 2) => {
  return request.get<PersonConfig>(`/api/users/personConfig/userGet?type=${type}`);
};

type ConfigType = {
  type: number
  config: string
}
/**
 * 设置用户个人配置
 */
export const setPersonConfig = (data: ConfigType) => {
  return request.post<DefaultSuccess>('/api/users/personConfig/userSet', {
    ...data
  });
};

/**
 * 更新会议记录浏览时间，会议有变更，用户确认时调用
 * @param userId
 * @param meetingId 会议Id
 * @returns DefaultSuccess
 */
export const updateMeetingReviewTime = (userId: string, meetingId: string) => {
  return request.put<DefaultSuccess>(`/api/users/${userId}/meeting_records/${meetingId}/state/review`);
};

/**
 * 设置日程已读
 * @param staffId
 * @param meetingId
 * @returns
 */
export const readMeetingRecord = (staffId: string, meetingId: string) => {
  return request.put<DefaultSuccess>(`/api/users/${staffId}/meeting_records/${meetingId}/state/read`);
};
